<template>
    <div style="padding:10px; border:1px solid #a0a0a0;height: 200px;overflow: auto">
        <h3 class="title-header">KİŞİSEL VERİLERİN KORUNMASI VE İŞLENMESİNE İLİŞKİN VATAN SOSYAL HİZMETLER TİCARET
            LİMİTED ŞİRKETİ WEB
            UYGULAMASI AYDINLATMA METNİ</h3>
        <p class="middle-p">
            İş bu aydınlatma metni, 6698 sayılı Kişisel Verilerin Korunması Kanununun 10. maddesi ile Aydınlatma
            Yükümlüğünün Yerine Getirilmesinde Uyulacak Usul ve
            Esaslar Hakkında Tebliğ kapsamında veri sorumlusu sıfatıyla <strong>VATAN SOSYAL HİZMETLER TİCARET LİMİTED
            ŞİRKETİ</strong> (<span class="highlight">Şirket</span>) tarafından
            <a href="https://kayit.desafe.com.tr">https://kayit.desafe.com.tr</a> (<span class="highlight">web tabanlı KVKK programı</span>)
            ve
            <a href="https://desafe.com.tr">www.desafe.com.tr</a> (<span class="highlight">web sitesi</span>) alan
            adına sahip web sitelerimizi ziyaret eden ziyaretçiler/kullanıcılar ile ilgili olarak,
            siteyi ziyaret ettikleri durumlarda paylaştıkları
            bilgi/verilerin işlenme süreçleriyle ilgili bilgilendirme amacıyla hazırlanmıştır.
        </p>

        <p class="middle-p">
            <strong>VATAN SOSYAL HİZMETLER TİCARET LİMİTED ŞİRKETİ </strong>olarak,
            kişisel verilerinizin işlenmesinde ve muhafaza edilmesinde 6698 sayılı
            "Kişisel Verilerin Korunması Kanunu'na uygun davranılmasına azami hassasiyet göstermekteyiz.
            Bu nedenle kişisel verilerinizi aşağıda açıklandığı şekilde ve mevzuatın çizdiği sınırlar çerçevesinde
            işlemekteyiz.

            <br/>
            Tarafımızca, bizimle paylaşmanız veya gerekli olması halinde, işlemeye konu olabilecek kişisel verileriniz
            aşağıdaki gibidir:

            <br/>

        </p>

        <table width="100%" border="1" cellpadding="0" cellspacing="0">
            <tr>
                <td>Kimlik</td>
                <td>Adınız</td>
                <td>Soyadınız</td>
            </tr>
            <tr>
                <td>İletişim Verisi</td>
                <td>Telefon Numaranız</td>
                <td>E Posta Adresiniz</td>
            </tr>
            <tr>
                <td colspan="3">Pazarlama Çerez Kayıtları</td>
            </tr>
        </table>
        <p class="middle-p">
            Yukarıda belirtilen Kişisel verileriniz; her koşulda hukuka ve dürüstlük kurallarına uygun olarak,
            paylaştığınız
            kişisel verilerin doğruluğunu ve en güncel halini koruyarak, belirli açık ve hukuka uygun amaçlar için
            işlenecekleri amaç ile bağlantılı, sınırlı ve ölçülü olarak işlenmektedir.
        </p>

        <p class="middle-p">
            <strong>Kişisel Verilerin Hangi Amaçla İşleneceği:</strong>
            <br/>
            <br/>

            Kişisel verileriz Şirket tarafından; online KVKK Uyum Danışmanlığı hizmetinin sunulabilmesi ve bu kapsamdaki
            faaliyetlerin yürütülmesi, hizmetlerimiz ile ilgili olarak tarafınızca iletişime geçilmesi, amaçlarıyla
            sınırlı
            olarak işlenmektedir.

            <br/>
            <br/>

            <strong>İşlenen Kişisel Verilerin Kimlere ve Hangi Amaçla Aktarılabileceği:</strong>
            <br/><br/>

            Bir kullanıcının, bir başka kullanıcının bilgilerine ulaşması ve bu bilgileri değiştirmesi mümkün olmamakla
            birlikte, kullanıcının kişisel bilgileri, …………..com haricinde yalnızca kullanıcı tarafından ulaşılabilir ve
            gerekmesi durumunda yukarıda yer alan kişisel verileriniz, yukarıda belirtilen amaçlarla, KVKK'da öngörülen
            temel ilkelere uygun olarak ve KVKK'nın 8. Ve 9. maddelerinde belirtilen kişisel veri işleme şartları ve
            amaçları dâhilinde, ŞİRKET tarafından, ilgili Kamu kurum ve kuruluşlarına, hukuki danışmanlık hizmeti alınan
            bürolara, Şirket faaliyetlerini ve iş süreçlerini devam ettirmek için hizmet sunan ilgili departmanlar ile
            Şirket adına kişisel veri işleyen yurt içi ve/veya yurt dışı hizmet sağlayıcılarına hukuki zorunluluklar ve
            yasal sınırlamalar çerçevesinde aktarılabilecektir.
            <br/><br/>

            <strong>Kişisel Veri Toplamanın Yöntemi ve Hukuki Sebebi:</strong>

            <br/><br/>

            Kişisel verileriniz, şirketimize yöneltmiş olduğunuz eğitim talebinize istinaden KVKK'nın 5. ve 6.
            maddelerinde
            belirtilen işleme şartlarından açık rızaya dayanarak yukarıda belirtilen amaçlarla elektronik ortamda
            toplanmaktadır ve işlendikleri amaç için gerekli olan süre kadar muhafaza edilmektedir.

            <br/><br/>

            <strong>Kişisel Veri Sahibinin KVKK'nın 11. Maddesinde Sayılan Hakları:</strong>

            <br/><br/>

            <strong>KVK Kanunu'nun 11. maddesi uyarınca, Şirketimize başvurarak kişisel verileriniz hakkında aşağıdaki
                konulara ilişkin taleplerde bulunabilirsiniz:</strong>

            <br/><br/>

        </p>

        <ul>
            <li>Kişisel verinin işlenip işlenmediğini öğrenme,</li>
            <li>Kişisel verileri işlenmişse buna ilişkin bilgi talep etme,</li>
            <li>Kişisel verilerin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme,</li>
            <li>Yurt içinde veya yurt dışında kişisel verilerin aktarıldığı üçüncü kişileri bilme,</li>
            <li>Kişisel verilerin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini isteme ve bu
                kapsamda yapılan işlemin kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme,
            </li>
            <li>6698 sayılı Kanun ve ilgili diğer kanun hükümlerine uygun olarak işlenmiş olmasına rağmen, işlenmesini
                gerektiren sebeplerin ortadan kalkması hâlinde kişisel verilerin silinmesini veya yok edilmesini isteme
                ve bu kapsamda yapılan işlemin kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme,
            </li>
            <li>İşlenen kişisel verilerin özellikle otomatik olarak analiz edilmesi neticesinde veri sahibinin aleyhine
                bir sonucun ortaya çıkmasına itiraz etme,
            </li>
            <li>Kişisel verilerin kanuna aykırı olarak işlenmesi sebebiyle zarara uğraması hâlinde zararın giderilmesini
                talep etme,
            </li>
        </ul>
        <div class="middle-p">
            <br/>
            Haklarına sahiptir.

            <br/><br/>

            <strong>Talep İletme Yöntemi:</strong>

            <br/><br/>

            Kanunun "ilgili kişinin haklarını düzenleyen" 11. maddesi kapsamındaki taleplerinizi, "Veri Sorumlusuna
            Başvuru
            Usul ve Esasları Hakkında Tebliğe" göre, Şirketin internet adresinde bulunan başvuru formunu doldurup
            imzalayarak, şahsen kimliğinizi ispatlamak suretiyle veya noter aracılığıyla Şirketimizin Topraklık
            Mahallesi,
            <pre>İzmir Bulvarı No: 17/A Pamukkale/Denizli adresine</pre>
            teslim/tebliğ edebilirsiniz ya da üyeliğinizin teyit
            edildiği
            elektronik posta üzerinden veya Kayıtlı elektronik posta (<span class="highlight">KEP</span>) adresiniz ile
            şirketimize iletebilirsiniz.
            Talebinizin niteliğine göre en kısa sürede ve en geç 30 (<span class="highlight">otuz</span>) gün içinde
            başvurularınız ücretsiz olarak
            sonuçlandırılacaktır. Ancak, işlemin ayrıca bir maliyet gerektirmesi halinde Kişisel Verileri Koruma Kurulu
            tarafından belirlenecek tarifeye göre tarafınızdan ücret talep edilebilecektir. Başvurulara verilecek
            cevapların
            10 (<span class="highlight">on</span>) sayfayı aşması halinde, her sayfa için 1,00 (<span
                class="highlight">bir</span>) TL işlem ücreti alınacaktır. Cevabın CD, flash
            bellek
            gibi kayıt ortamında verilmesinin istenmesi halinde, istenen kayıt ortamının maliyetine göre ücret talep
            edilecektir.

            <br/><br/>

            <strong>Değişiklikler:</strong>

            <br/><br/>

            Mevzuat değişikliklerine bağlı olarak aydınlatma metninde değişiklik yapılabilecektir. Değişiklik söz konusu
            olduğunda, internet sitemizde gerekli duyurular yapılacak olup, bu değişikliklerden haberdar olabilmeniz
            için
            internet sitemizi düzenli olarak ziyaret etmeniz uygun olacaktır.
        </div>


    </div>
</template>

<script>
    export default {
        name: "KVKKComponent"
    }
</script>

<style scoped>

</style>
